// Слой строк UI (NFR-09, i18n-готовность). v1 — ru по умолчанию; все видимые тексты app-ui берутся
// отсюда, чтобы будущий i18n подменял словарь без правки экранов. Даты/время локализуются к таймзоне
// клиента в design-system (util/format), здесь — статические подписи.

export const strings = {
  app: {
    title: 'Мессенджер',
    loading: 'Загрузка…',
  },
  nav: {
    chats: 'Чаты',
    search: 'Поиск',
    settings: 'Настройки',
    admin: 'Администрирование',
    back: 'Назад',
    newChat: 'Новый чат',
    newGroup: 'Новая группа',
  },
  empty: {
    noChats: 'Начните переписку',
    noChatsHint: 'Выберите коллегу в директории, чтобы написать сообщение',
    selectChat: 'Выберите чат',
    noMessages: 'Нет сообщений',
    searchNothing: 'Ничего не найдено',
    directoryEmpty: 'Пользователи не найдены',
    adminQueueEmpty: 'Нет заявок на рассмотрение',
    noUsers: 'Пользователей пока нет',
  },
  conn: {
    offline: 'Нет соединения, сообщения уйдут позже',
    reconnecting: 'Переподключение…',
    outdated: 'Обновите страницу — версия протокола устарела',
    reload: 'Обновить',
  },
  composer: {
    placeholder: 'Сообщение',
    reply: 'Ответ',
    editing: 'Редактирование',
    cancel: 'Отменить',
    mentionsHint: 'Упомянуть участника',
    dropHint: 'Отпустите файлы, чтобы отправить',
    pasteFromClipboard: 'Вставить из буфера',
    // Главный кейс пустого буфера на iOS — фото из «Галереи» (система не отдаёт его в веб-буфер);
    // ведём к скрепке, где в iOS-пикере есть «Медиатека».
    clipboardEmpty: 'В буфере нет файла — прикрепите скрепкой 📎',
  },
  message: {
    reply: 'Ответить',
    forward: 'Переслать',
    edit: 'Изменить',
    deleteForAll: 'Удалить у всех',
    deleteForMe: 'Удалить у себя',
    copy: 'Копировать текст',
    retry: 'Повторить',
    discard: 'Удалить',
    failed: 'Не отправлено',
    deleted: 'Сообщение удалено',
    react: 'Реакция',
    /** BR-10: подпись у сообщения, пришедшего через мост из Telegram. */
    fromTelegram: 'из Telegram',
    /** BR-10: к имени автора из Telegram, не сопоставленного с сотрудником. */
    externalAuthorSuffix: ' (Telegram)',
  },
  chat: {
    pin: 'Закрепить',
    unpin: 'Открепить',
    mute: 'Без звука',
    unmute: 'Включить звук',
    archive: 'Архивировать',
    unarchive: 'Из архива',
    markRead: 'Прочитать',
    leave: 'Выйти из группы',
    membersCount: (n: number): string => `${n} ${plural(n, 'участник', 'участника', 'участников')}`,
    online: 'в сети',
    profile: 'Профиль',
    readers: 'Кто прочитал',
  },
  notif: {
    newMessage: 'Новое сообщение',
    settings: 'Уведомления',
    sound: 'Звук',
    preview: 'Показывать превью',
    modeAll: 'Все сообщения',
    modeMentions: 'Только упоминания',
    updateAvailable: 'Доступно обновление',
    install: 'Установить приложение',
    installIosHint: 'Нажмите «Поделиться» → «На экран Домой», чтобы установить',
    enablePush: 'Включить уведомления',
    disablePush: 'Выключить уведомления',
    pushOn: 'Уведомления включены на этом устройстве',
    pushOff: 'Уведомления выключены',
    enableFirst: 'Включите уведомления, чтобы настроить параметры',
    pushDenied: 'Разрешение заблокировано — включите уведомления в настройках браузера',
    pushUnsupported: 'Push-уведомления не поддерживаются в этом браузере',
    iosInstallFirst: 'Сначала установите приложение на экран «Домой», затем включите уведомления',
  },
  auth: {
    signIn: 'Вход',
    signUp: 'Регистрация',
    email: 'Email',
    password: 'Пароль',
    name: 'Имя',
    title: 'Должность',
    department: 'Отдел',
    submitSignIn: 'Войти',
    submitSignUp: 'Зарегистрироваться',
    toSignUp: 'Создать аккаунт',
    toSignIn: 'У меня есть аккаунт',
    pendingTitle: 'Заявка отправлена',
    pendingBody: 'Дождитесь одобрения администратором — после активации вы сможете войти.',
    reloginTitle: 'Сессия истекла',
    reloginBody: 'Войдите снова — черновики и очередь сохранены.',
    invalidCreds: 'Неверный email или пароль',
    pendingApproval: 'Аккаунт ожидает одобрения администратором (или деактивирован)',
    corpDomainHint: 'Используйте корпоративный email',
    passwordHint: 'Пароль — минимум 8 символов',
    passwordTooShort: (n: number): string => `Пароль слишком короткий — минимум ${n} символов`,
    badEmail: 'Некорректный email',
    emailTaken: 'Этот email уже зарегистрирован',
    corpOnly: 'Регистрация доступна только с корпоративного email',
  },
  /** PWD-4: экран обязательной смены пароля (пароль выдал администратор). */
  forcePassword: {
    title: 'Задайте свой пароль',
    body: 'Вы вошли по временному паролю от администратора. Придумайте свой — дальше входите только с ним.',
    current: 'Временный пароль',
    next: 'Новый пароль',
    confirm: 'Повторите новый пароль',
    hint: (n: number): string => `Не короче ${n} символов. Не используйте пароль от почты.`,
    submit: 'Сохранить и войти',
    logout: 'Выйти',
    tooShort: (n: number): string => `Пароль слишком короткий — минимум ${n} символов`,
    mismatch: 'Новые пароли не совпадают',
    sameAsTemp: 'Новый пароль должен отличаться от временного',
    wrongCurrent: 'Временный пароль введён неверно',
  },
  settings: {
    profile: 'Профиль',
    notifications: 'Уведомления',
    appearance: 'Оформление',
    theme: 'Тема',
    themeLight: 'Светлая',
    themeDark: 'Тёмная',
    themeSystem: 'Как система',
    sessions: 'Сессии и устройства',
    changePassword: 'Сменить пароль',
    currentPassword: 'Текущий пароль',
    newPassword: 'Новый пароль',
    confirmPassword: 'Повторите новый пароль',
    passwordChanged: 'Пароль изменён',
    passwordMismatch: 'Новые пароли не совпадают',
    passwordChangeFailed: 'Не удалось сменить пароль — проверьте текущий пароль',
    logoutHere: 'Выйти здесь',
    logoutAll: 'Выйти на всех устройствах',
    revoke: 'Завершить',
    save: 'Сохранить',
    saved: 'Сохранено',
    changeAvatar: 'Сменить фото',
    avatarUpdated: 'Фото профиля обновлено',
    nameEmpty: 'Имя не может быть пустым',
    nameTooLong: (n: number): string => `Имя слишком длинное — максимум ${n} символов`,
    titleTooLong: (n: number): string => `Должность слишком длинная — максимум ${n} символов`,
    departmentTooLong: (n: number): string => `Отдел слишком длинный — максимум ${n} символов`,
  },
  admin: {
    pending: 'Заявки на регистрацию',
    users: 'Пользователи',
    audit: 'Аудит',
    approve: 'Одобрить',
    deactivate: 'Деактивировать',
    makeAdmin: 'Назначить админом',
    makeMember: 'Снять роль админа',
    resetPassword: 'Сбросить пароль',
    passwordReset: 'Пароль сброшен',
    roleAdmin: 'админ',
    roleMember: 'участник',
    deleteUser: 'Удалить',
    userDeleted: 'Пользователь удалён',
    deleteConfirmTitle: 'Удалить пользователя?',
    deleteConfirmBody: (name: string): string =>
      `Учётная запись «${name}» и весь её след (сообщения, личные чаты, членства, подписки) будут удалены безвозвратно. Действие нельзя отменить.`,
    deleteConfirmYes: 'Удалить безвозвратно',
    deleteConfirmNo: 'Отмена',
    active: 'активен',
    pendingBadge: 'ожидает одобрения',
    you: '(вы)',
    edit: 'Редактировать',
    editTitle: 'Параметры пользователя',
    editRole: 'Роль',
    editActive: 'Активен',
    editInactiveHint: 'Имя, должность и отдел можно править только у активного пользователя',
    editPasswordHint: 'Оставьте пустым, чтобы не менять пароль',
    editCancel: 'Отмена',
    lastAdminConflict: 'Нельзя деактивировать или разжаловать последнего активного администратора',
  },
  groupInfo: {
    title: 'Информация о группе',
    directTitle: 'Профиль',
    name: 'Название группы',
    members: 'Участники',
    addMember: 'Добавить участника',
    removeMember: 'Удалить из группы',
    changeAvatar: 'Сменить фото',
    cropTitle: 'Обрезка фото',
    cropDone: 'Готово',
    cropZoom: 'Масштаб',
    roleOwner: 'владелец',
    roleAdmin: 'админ',
    deleteGroup: 'Удалить группу',
    deleteConfirmTitle: 'Удалить группу?',
    deleteConfirmBody:
      'Группа и вся переписка будут безвозвратно удалены у всех участников. Действие нельзя отменить.',
    deleteConfirmYes: 'Удалить безвозвратно',
    deleteConfirmNo: 'Отмена',
    deleted: 'Группа удалена',
    saved: 'Сохранено',
    avatarUpdated: 'Фото группы обновлено',
    memberAdded: 'Участник добавлен',
    memberRemoved: 'Участник удалён',
    searchPlaceholder: 'Поиск коллег',
  },
  search: {
    placeholder: 'Поиск по сообщениям и чатам',
    scopeGlobal: 'Везде',
    scopeChat: 'В этом чате',
  },
  errors: {
    sendFailed: 'Не удалось отправить',
    actionFailed: 'Не удалось выполнить действие',
    uploadTooLarge: 'Файл слишком большой',
    unsupportedImage: 'Неподдерживаемый формат изображения — нужен JPEG, PNG или WebP',
    uploadFailed: 'Не удалось загрузить файл',
    generic: 'Произошла ошибка',
    tooManyAttempts: 'Слишком много попыток — попробуйте позже',
    checkFields: 'Проверьте правильность заполнения полей',
    messageTooLong: (n: number): string => `Сообщение слишком длинное — максимум ${n.toLocaleString('ru-RU')} символов`,
  },
} as const

/** Русская плюрализация (1 участник / 2 участника / 5 участников). */
export function plural(n: number, one: string, few: string, many: string): string {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return one
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return few
  return many
}
